// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Client from "@apollo/client";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let DuplicateProduct_SourceIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogDuplicationFormMutations.DuplicateProduct_SourceIdNotFound");

let DuplicateProduct_DestinationIdsMissing = /* @__PURE__ */Primitive_exceptions.create("CatalogDuplicationFormMutations.DuplicateProduct_DestinationIdsMissing");

let DuplicateVariant_SourceIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogDuplicationFormMutations.DuplicateVariant_SourceIdNotFound");

let DuplicateVariant_DestinationIdsMissing = /* @__PURE__ */Primitive_exceptions.create("CatalogDuplicationFormMutations.DuplicateVariant_DestinationIdsMissing");

let Raw = {};

let query = Client.gql(["mutation duplicateProduct($id: ID!, $input: InputDuplicateProduct!)  {\nduplicateProduct(id: $id, input: $input)  {\n__typename  \nid  \nname  \nshop  {\n__typename  \nname  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.duplicateProduct;
  let value$2 = value$1.shop;
  return {
    duplicateProduct: {
      __typename: value$1.__typename,
      id: value$1.id,
      name: value$1.name,
      shop: {
        __typename: value$2.__typename,
        name: value$2.name
      }
    }
  };
}

function serialize(value) {
  let value$1 = value.duplicateProduct;
  let value$2 = value$1.shop;
  let value$3 = value$2.name;
  let value$4 = value$2.__typename;
  let shop = {
    __typename: value$4,
    name: value$3
  };
  let value$5 = value$1.name;
  let value$6 = value$1.id;
  let value$7 = value$1.__typename;
  let duplicateProduct = {
    __typename: value$7,
    id: value$6,
    name: value$5,
    shop: shop
  };
  return {
    duplicateProduct: duplicateProduct
  };
}

function serializeInputObjectInputDuplicateProductLinkTo(inp) {
  let a = inp.categoryId;
  return {
    shopId: inp.shopId,
    categoryId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputDuplicateProduct(inp) {
  let a = inp.linkTo;
  return {
    linkTo: a.map(serializeInputObjectInputDuplicateProductLinkTo)
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputDuplicateProduct(inp.input)
  };
}

function makeVariables(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputDuplicateProduct(linkTo, param) {
  return {
    linkTo: linkTo
  };
}

function makeInputObjectInputDuplicateProductLinkTo(shopId, categoryId, param) {
  return {
    shopId: shopId,
    categoryId: categoryId
  };
}

let DuplicateProductMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputDuplicateProduct: serializeInputObjectInputDuplicateProduct,
  serializeInputObjectInputDuplicateProductLinkTo: serializeInputObjectInputDuplicateProductLinkTo,
  makeVariables: makeVariables,
  makeInputObjectInputDuplicateProduct: makeInputObjectInputDuplicateProduct,
  makeInputObjectInputDuplicateProductLinkTo: makeInputObjectInputDuplicateProductLinkTo
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let DuplicateProductMutation_useWithVariables = include.useWithVariables;

let DuplicateProductMutation = {
  DuplicateProductMutation_inner: DuplicateProductMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputDuplicateProduct: serializeInputObjectInputDuplicateProduct,
  serializeInputObjectInputDuplicateProductLinkTo: serializeInputObjectInputDuplicateProductLinkTo,
  makeVariables: makeVariables,
  makeInputObjectInputDuplicateProduct: makeInputObjectInputDuplicateProduct,
  makeInputObjectInputDuplicateProductLinkTo: makeInputObjectInputDuplicateProductLinkTo,
  use: use,
  useWithVariables: DuplicateProductMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation duplicateVariant($id: ID!, $input: InputDuplicateVariant!)  {\nduplicateVariant(id: $id, input: $input)  {\n__typename  \nid  \nname  \nshop  {\n__typename  \nname  \n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.duplicateVariant;
  let value$2 = value$1.shop;
  return {
    duplicateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      name: value$1.name,
      shop: {
        __typename: value$2.__typename,
        name: value$2.name
      }
    }
  };
}

function serialize$1(value) {
  let value$1 = value.duplicateVariant;
  let value$2 = value$1.shop;
  let value$3 = value$2.name;
  let value$4 = value$2.__typename;
  let shop = {
    __typename: value$4,
    name: value$3
  };
  let value$5 = value$1.name;
  let value$6 = value$1.id;
  let value$7 = value$1.__typename;
  let duplicateVariant = {
    __typename: value$7,
    id: value$6,
    name: value$5,
    shop: shop
  };
  return {
    duplicateVariant: duplicateVariant
  };
}

function serializeInputObjectInputDuplicateVariantLinkTo(inp) {
  return {
    productId: inp.productId
  };
}

function serializeInputObjectInputDuplicateVariant(inp) {
  let a = inp.linkTo;
  return {
    linkTo: a.map(b => ({
      productId: b.productId
    }))
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputDuplicateVariant(inp.input)
  };
}

function makeVariables$1(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputDuplicateVariant(linkTo, param) {
  return {
    linkTo: linkTo
  };
}

function makeInputObjectInputDuplicateVariantLinkTo(productId, param) {
  return {
    productId: productId
  };
}

let DuplicateVariantMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputDuplicateVariant: serializeInputObjectInputDuplicateVariant,
  serializeInputObjectInputDuplicateVariantLinkTo: serializeInputObjectInputDuplicateVariantLinkTo,
  makeVariables: makeVariables$1,
  makeInputObjectInputDuplicateVariant: makeInputObjectInputDuplicateVariant,
  makeInputObjectInputDuplicateVariantLinkTo: makeInputObjectInputDuplicateVariantLinkTo
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let DuplicateVariantMutation_useWithVariables = include$1.useWithVariables;

let DuplicateVariantMutation = {
  DuplicateVariantMutation_inner: DuplicateVariantMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputDuplicateVariant: serializeInputObjectInputDuplicateVariant,
  serializeInputObjectInputDuplicateVariantLinkTo: serializeInputObjectInputDuplicateVariantLinkTo,
  makeVariables: makeVariables$1,
  makeInputObjectInputDuplicateVariant: makeInputObjectInputDuplicateVariant,
  makeInputObjectInputDuplicateVariantLinkTo: makeInputObjectInputDuplicateVariantLinkTo,
  use: use$1,
  useWithVariables: DuplicateVariantMutation_useWithVariables
};

function useDuplicateProduct() {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback((param, state) => {
    let match = state.source;
    let id;
    if (match !== undefined) {
      if (match.TAG === "Product") {
        id = match._0.id;
      } else {
        throw {
          RE_EXN_ID: DuplicateProduct_SourceIdNotFound,
          Error: new Error()
        };
      }
    } else {
      throw {
        RE_EXN_ID: DuplicateProduct_SourceIdNotFound,
        Error: new Error()
      };
    }
    let linkTo = Stdlib_Array.filterMap(state.destinations, destination => {
      if (destination.TAG === "Category") {
        let match = destination._0;
        let shopId = match.shopId;
        if (shopId !== undefined) {
          return [
            shopId,
            match.id
          ];
        } else {
          return;
        }
      }
      let shopId$1 = destination._0.shopId;
      if (shopId$1 !== undefined) {
        return [
          shopId$1,
          undefined
        ];
      }
    });
    let input = {
      linkTo: linkTo.map(param => ({
        shopId: param[0],
        categoryId: param[1]
      }))
    };
    if (linkTo.length !== state.destinations.length) {
      throw {
        RE_EXN_ID: DuplicateProduct_DestinationIdsMissing,
        Error: new Error()
      };
    }
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id,
      input: input
    })), undefined, param => {
      let match = param.duplicateProduct;
      return I18n.template(linkTo.length > 1 ? I18n.t("The product \"{{referenceName}}\" from catalog {{shopName}} has been correctly added to the selected shops.") : I18n.t("The product \"{{referenceName}}\" from catalog {{shopName}} has been correctly added to your shop."), {
        referenceName: match.name,
        shopName: match.shop.name
      }, undefined);
    });
  }, []);
}

function useDuplicateVariant() {
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback((param, state) => {
    let match = state.source;
    let id;
    if (match !== undefined) {
      if (match.TAG === "Product") {
        throw {
          RE_EXN_ID: DuplicateVariant_SourceIdNotFound,
          Error: new Error()
        };
      }
      id = match._0.id;
    } else {
      throw {
        RE_EXN_ID: DuplicateVariant_SourceIdNotFound,
        Error: new Error()
      };
    }
    let productIds = Stdlib_Array.filterMap(state.destinations, x => {
      if (x.TAG === "Category") {
        return;
      } else {
        return x._0.id;
      }
    });
    let input = {
      linkTo: productIds.map(productId => ({
        productId: productId
      }))
    };
    if (productIds.length !== state.destinations.length) {
      throw {
        RE_EXN_ID: DuplicateVariant_DestinationIdsMissing,
        Error: new Error()
      };
    }
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id,
      input: input
    })), undefined, param => {
      let match = param.duplicateVariant;
      return I18n.template(productIds.length > 1 ? I18n.t("The variant \"{{referenceName}}\" from catalog {{shopName}} has been correctly added to the selected shops.") : I18n.t("The variant \"{{referenceName}}\" from catalog {{shopName}} has been correctly added to your shop."), {
        referenceName: match.name,
        shopName: match.shop.name
      }, undefined);
    });
  }, []);
}

export {
  DuplicateProduct_SourceIdNotFound,
  DuplicateProduct_DestinationIdsMissing,
  DuplicateVariant_SourceIdNotFound,
  DuplicateVariant_DestinationIdsMissing,
  DuplicateProductMutation,
  DuplicateVariantMutation,
  useDuplicateProduct,
  useDuplicateVariant,
}
/* query Not a pure module */
